import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/fdc24f70-1f67-42d7-a2fe-d19be589acb8.png" 
              alt="EURIPUS d.o.o. Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`font-serif text-xl font-medium ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              EURIPUS d.o.o.
            </span>
          </div>
          
          <div className="flex items-center gap-12">
            {['home', 'about', 'products', 'features', 'contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`text-sm font-light capitalize transition-all duration-300 hover:opacity-100 whitespace-nowrap cursor-pointer ${
                  scrolled ? 'text-gray-900/70 hover:text-gray-900' : 'text-white/70 hover:text-white'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className={`h-px ${scrolled ? 'bg-gray-200' : 'bg-white/10'}`}></div>
    </nav>
  );
}
